module.exports = __webpack_public_path__ + "img/724.47ce627c.png";